var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M13.1892 7.25L8.93923 2.99999L9.99989 1.93933L16.0605 7.99999L9.99989 14.0607L8.93923 13L13.1892 8.75H0.25V7.25H13.1892Z","fill":"#181818"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"d":"M0 0H16V16H0V0Z","fill":"white"})))]);
}

ArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
